import React from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Images } from "../../../utils/Images";

// Format currency helper
const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return "₹ 0";
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  return `₹ ${numAmount.toLocaleString('en-IN')}`;
};

const StatCards = ({ user }) => {
  // Move hooks inside the component function
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery("(max-width:359px)");

  // Get values from user profile API
  const totalDonations = user?.totalDonerAmounts ?? 0;
  const campaignsSupported = user?.totalcampaign ?? user?.totalCampaign ?? 0;

  const cardData = [
    {
      icon: Images.chartIcon,
      bgColor: "#A9C74E",
      label: "Total Donations",
      value: formatCurrency(totalDonations),
    },
    {
      icon: Images.moneyIcon,
      bgColor: "#A9C74E",
      label: "Campaigns Supported",
      value: campaignsSupported.toString(),
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        gap: isMobile ? "16px" : "21px",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: isSmallMobile ? "wrap" : "nowrap",
      }}
    >
      {cardData.map((card, idx) => (
        <Box
          key={idx}
          sx={{
            display: "flex",
            alignItems: "center",
            p: isMobile ? "16px 10px" : " 16px",
            bgcolor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 8px 24px 0 rgba(27, 46, 94, 0.12)",
            width: "100%",
            border: "1px solid #DBE0E5",
            gap: isMobile ? "6px " : "16px",
          }}
        >
          <Box
            sx={{
              bgcolor: card.bgColor,
              borderRadius: "6px",
              minWidth: isMobile ? "30px" : "60px",
              height: isMobile ? "30px" : "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={card.icon}
              alt={card.label}
              style={{
                width: isMobile ? "16px" : 32,
                height: isMobile ? "16px" : 32,
              }}
            />
          </Box>
          <Box>
            <Typography
              variant="subtitle2"
              sx={{
                color: "#4A4A49",
                fontSize: isMobile ? "10px" : "14px",
                fontWeight: "400",
                lineHeight: isMobile ? "100%" : "20px",
              }}
            >
              {card.label}
            </Typography>
            <Typography
              variant={!card.value.startsWith("₹") ? "h5" : "h4"}
              sx={{
                color: "#1D1D1B",
                mt: isMobile ? "6px" : "10px",
                fontSize: isMobile ? "14px" : "22px",
                fontWeight: "800",
                lineHeight: isMobile ? "100%" : "20px",
              }}
            >
              {card.value}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default StatCards;
